import type { ActivityType, CalculationMode, LeaderboardVisibility, ManagerRole, Permission } from "@hrhub/shared";

export interface SessionUser {
  discordId: string;
  username: string;
  globalName: string | null;
  nickname: string | null;
  displayName: string;
  avatarUrl: string;
  managerRole: ManagerRole | null;
  permissions: Permission[];
  isHrMember: boolean;
  isManager: boolean;
}

export interface Team {
  id: string;
  name: string;
  color: string;
  discordRoleId?: string;
  discordRoleIds?: string[];
  description?: string;
  priority?: number;
  isActive?: boolean;
  allowedActivityTypes?: ActivityType[];
  systemKey?: "INTERVIEW" | "TRAINING" | null;
}

export interface RosterMember {
  discordId?: string;
  username: string;
  globalName: string | null;
  nickname: string | null;
  displayName: string;
  avatarUrl: string;
  isActiveHr: boolean;
  archivedAt: string | null;
  joinedHrAt: string | null;
  allTimeInterviews: number;
  allTimeTrainings: number;
  monthInterviews: number;
  monthTrainings: number;
  requirementStatus: "ACTIVE" | "INACTIVE";
  requirementProgress: number;
  activityStreak: number;
  primaryTeam: Team | null;
  teams: Team[];
}

export interface PublicSettings {
  hubName: string;
  logoUrl: string;
  accentColor: string;
  timezone: string;
  leaderboardVisibility: LeaderboardVisibility;
  heatmapEnabled: boolean;
  maxQuantityPerSubmission: number;
  notesRequired: boolean;
  notesMaxLength: number;
  allowBackdating: boolean;
  allowMultipleTeams: boolean;
  interviewRequirement: number;
  trainingRequirement: number;
  combinedRequirement: number;
  calculationMode: CalculationMode;
  devAuthBypass: boolean;
}

export interface Recruit {
  discordId: string;
  username: string;
  globalName: string | null;
  nickname: string | null;
  displayName: string;
  avatarUrl: string;
  isAwaiting: boolean;
  awaitingSince: string;
  lastSeenAt: string;
  trainedAt: string | null;
  waitingMs: number;
}

export interface Paginated<T> {
  items: T[];
  total: number;
  page: number;
  limit: number;
}

export function can(user: SessionUser | null | undefined, permission: Permission) {
  return Boolean(user?.permissions.includes(permission));
}

export function effectiveRequirementStatus(member: Pick<RosterMember, "requirementStatus" | "teams" | "primaryTeam">) {
  const teams = member.teams.length ? member.teams : member.primaryTeam ? [member.primaryTeam] : [];
  if (!teams.length) return "INACTIVE";
  return member.requirementStatus;
}
